import React, { Component } from "react";
import ActividadesEducacionService from "../../../services/pagos/ActividadesEducacionService";
import { trackPromise } from "react-promise-tracker";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPrint } from "@fortawesome/free-solid-svg-icons";
//// componentes reutilizables
import Titulo from "../../generico/TituloPagina";
import AuthService from "../../../services/login/auth.service";
import { formatoSeparadorMilesValue } from "../../generico/utils/FormatoInput";


export default class MisCompras extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();

  }
  resetState = () => {
    this.setState(this.getInitialState());

  };
  getInitialState = () => ({

    listaEducacion: [],
    actividad: {},
    cuentaDebito: {},
    nroOperacion: "",
    cantidadEntradas: undefined,

  });

 

//para reimprimir tickets
  descargarComprobanteCompras = async (elemento) => {
   
    var nroActividad = elemento.actividad;
    var nombreActividad = elemento.descripcion;
    var fecha = elemento.fecha;
    var hora = elemento.hora;
    var ciudad = '-';
    var local = elemento.local;
    var costo = formatoSeparadorMilesValue(elemento.total);
    var moneda = elemento.moneda;
    var nroOperacion=elemento.movimiento;
    await trackPromise(
      ActividadesEducacionService.descargarComprobanteCompras("Pago de Actividades", nroOperacion, 
        AuthService.getSocio().numeroSocio.trim() + " - " + AuthService.getSocio().nombreCompleto,elemento.cuentaDebito, 
      moneda, "Inscripción de la Actividad", nroActividad,
       nombreActividad, fecha, hora, ciudad, costo + " " + moneda, costo + " " + moneda, local)
        .then((response) => {
          var fileURL = URL.createObjectURL(response.data);
          window.open(fileURL, "");
        })
        .catch(function (error) {
          console.log(error);
        })
    );

    this.setState({ listaFactura: true });
    // return listaFactura;
  };




//listado de compras
  getActividades() {
    trackPromise(
      ActividadesEducacionService.getComprasTicket().then((response) => {
        var data = JSON.stringify(response.data);
        var jData = JSON.parse(data);
        if (jData.codigoRetorno === "0") {
          this.setState({ listaEducacion: jData.datos });
        } else {
          this.setState({
            mensaje: jData.mensajeRetorno,
          });
        }
      })
    );
  }


  componentDidMount() {
    this.getActividades();
  }


  render() {
    var empresasFiltrado = this.state.listaEducacion;
    return (
      <div className="content-wrapper">
        <Titulo texto="Mis Compras" />
        <section className="content">
          <div className="container">
            <div className="row">
              <div className="col-md-12">

                {empresasFiltrado.length === 0
                  ? <p>Sin Resultados</p>
                  : empresasFiltrado.map(elemento =>
                    <div className="card">
                      <div className="card-body">
                        <div className="row">
                          <div className="col-lg-10 col-md-9 col-12">

                            <p className="card-title">{elemento.descripcion}</p>
                            <p className="card-text "></p>
                            <p className="card-text "><span className="titTextC">Actividad N°: </span><span className="titValueC">{elemento.actividad}</span> </p>
                            <p className="card-text"><span className="titTextC">Monto Total: </span> <span className="titValueC">{formatoSeparadorMilesValue(elemento.total)}  {elemento.moneda}</span></p>
                            <p className="card-text"><span className="titTextC">Fecha:  </span><span className="titValueC">{elemento.fecha} {elemento.hora}</span></p>

                          </div>
                          <div className="col-lg-2 col-md-3 col-12">
                            <button onClick={(evt) => {

                              this.descargarComprobanteCompras(elemento);
                            }} className="btn btn-cu-primary float-right">
                              <FontAwesomeIcon icon={faPrint} /> Reimprimir
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )} </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
